import { createSelector } from '@reduxjs/toolkit';

import {
  DataSourceType,
  SAMPLE_MUSIC_DATA_SOURCE_TYPE,
  TypeDescriptionCombinedOption,
} from 'src/constants/dataSourceTypeDescription';
import { SAMPLE_MUSIC_DATA_SOURCE } from 'src/constants/sampleDataSource';
import { dataSourceTypeDescriptionSelector } from 'src/selectors/dataSourceTypeDescription';
import { Connection } from 'src/store/connections/types';

export const dataSourcePropertiesSelector = (
  connection: Connection | null,
  type: DataSourceType
) =>
  createSelector(
    dataSourceTypeDescriptionSelector(connection),
    (typeDescription) => {
      // For sample music data source, use the underlying MYSQL type
      const actualType =
        type === SAMPLE_MUSIC_DATA_SOURCE_TYPE
          ? SAMPLE_MUSIC_DATA_SOURCE.type
          : type;
      const dataSourceInfo = typeDescription.DATA_SOURCE_TYPES[actualType];
      if (!dataSourceInfo) {
        // Return empty object if type doesn't exist
        return {};
      }
      const familyOptions =
        typeDescription.DATA_SOURCE_FAMILIES[dataSourceInfo.dataSourceFamily]
          .DATA_SOURCE_OPTIONS;
      const allProperties = new Set<string>([
        ...Object.keys(dataSourceInfo.DATA_SOURCE_OPTIONS || {}),
        ...Object.keys(familyOptions),
      ]);
      return Array.from(allProperties).reduce<
        Partial<Record<DataSourceType, TypeDescriptionCombinedOption>>
      >(
        (agg, property) => ({
          ...agg,
          [property]: {
            ...(typeDescription.DATA_SOURCE_OPTIONS[property] || {}),
            ...(familyOptions[property] || {}),
            ...(dataSourceInfo.DATA_SOURCE_OPTIONS?.[property] || {}),
          },
        }),
        {}
      );
    }
  );
